import React from 'react'

const SvgMapFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M15 5.365v14.608a5.632 5.632 0 01-.684-.113L9 18.606V4.009c.28.026.614.089 1 .188l4.95 1.182.05-.014zm2-.574l2.469-.709a2.09 2.09 0 011.792.302c.47.34.739.851.739 1.4v11.338c0 .783-.548 1.467-1.364 1.702L17 19.736V4.791zM7 19.19l-2.469.721c-.19.054-.386.082-.584.082-.433 0-.86-.132-1.208-.385-.47-.34-.739-.85-.739-1.4V7.082c0-.785.548-1.469 1.365-1.703L7 4.33V19.19z' />
  </svg>
)

export default SvgMapFilled
